<template>
	<div>
		<div class="main">
			<BaseInput>
				<textarea class="resize-y w-full shadow-m h-32" v-model="note.text" :disabled="false" @input="checkChanged"></textarea>
			</BaseInput>
		</div>
		<div class="flex justify-end">
			<BaseButton @click="save" :disabled="buttonState" class="mb-4 btn-blue">{{ $t('general.save') }}</BaseButton>
		</div>
	</div>
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import DamageCaseNoteRepository from '@/api/repositories/DamageCaseNoteRepository';

export default {
	name: 'NoteEdit',
	components: { BaseInput, BaseButton },
	data() {
		return {
			note: {},
			buttonState: true,
		};
	},
	mounted() {
		if (this.$route.params.noteId != null) {
			new DamageCaseNoteRepository().showNote(this.$route.params.noteId).then(response => {
				this.note = response.data.data;
			});
		}
	},
	methods: {
		checkChanged() {
			this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
			this.buttonState = !this.note.text;
		},
		save() {
			if (this.$route.params.noteId != null) {
				new DamageCaseNoteRepository()
					.updateNote(this.$route.params.noteId, this.note)
					.then(response => {
						this.$store.commit('setConfirmLeaving', false);
						this.$swal(this.$t('general.success').toString(), this.$t('notes_saved_successfully').toString(), 'success').then(_ => {
							this.$store.dispatch('forceUpdateDamageCase', { id: parseInt(this.$route.params.processId) });
							this.$router.go(-1);
						});
					})
					.catch(e => {
						this.$swal(this.$t('general.error').toString(), this.$t('notes_not_saved').toString(), 'error');
					});
			} else {
				this.note.damage_case_id = this.$route.params.processId;
				new DamageCaseNoteRepository()
					.storeNote(this.note)
					.then(response => {
						this.$store.commit('setConfirmLeaving', false);
						this.$swal(this.$t('general.success').toString(), this.$t('notes_saved_successfully').toString(), 'success').then(_ => {
							this.$store.dispatch('forceUpdateDamageCase', { id: parseInt(this.$route.params.processId) });
							this.$router.go(-1);
						});
					})
					.catch(e => {
						this.$swal(this.$t('general.error').toString(), this.$t('notes_not_saved').toString(), 'error');
					});
			}
		},
	},
};
</script>
